const commonStrings = {
  sidebar: {
    logoImageAltText: 'vezeeta logo',
  },
  multiSelectDropdownFilter: {
    applyBtn: 'Apply',
    cancelBtn: 'Clear',
  },
};

export default commonStrings;
